module.exports = __webpack_public_path__ + "static/media/  (75).0a60d316.jpg";